import { render, staticRenderFns } from "./InvestmentsProfile.vue?vue&type=template&id=661117c9&"
import script from "./InvestmentsProfile.vue?vue&type=script&lang=js&"
export * from "./InvestmentsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports